import { useGateValue } from "@statsig/react-bindings";

import { useFeatureFlag } from "@/features/featureFlag";

/**
 * Custom hook to check if Vibe Lab is enabled.
 *
 * Returns `true` if either the local feature flag ("enable-vibe-lab")
 * or the Statsig feature gate ("enable_vibe_lab") is enabled.
 */
export const useEnableVibeLab = (): boolean => {
  const featureFlag = useFeatureFlag("enable-vibe-lab");
  const featureGate = useGateValue("enable_vibe_lab");
  return featureFlag || featureGate;
};
